export enum CompletionType {
  TASK = 'task',        // Regular task completion
  TODO_ITEM = 'todo',   // Todo item completion
  ISSUE = 'issue'       // Full issue completion
}
